import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchFruits = (params) =>
  api.get("/fruits", { params }).then((r) => r.data);

export const fetchFruit = (slug) =>
  api.get(`/fruits/${slug}`).then((r) => r.data);

export const fetchRandom = (soloCanonici = false) =>
  api.get("/fruits/random", { params: soloCanonici ? { solo_canonici: true } : {} }).then((r) => r.data);

export const fetchFeatured = () => api.get("/fruits/featured").then((r) => r.data);

export const fetchMeta = () => api.get("/meta").then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);

// Costruisce l'URL completo dell'immagine (servita dal proxy backend).
export const imgSrc = (immagine) =>
  immagine ? (immagine.startsWith("http") ? immagine : `${BACKEND_URL}${immagine}`) : null;

export const CANON_COLORS = {
  "Canonico": { bg: "#eafaf0", color: "#0f8a4d", dot: "#22c55e" },
  "Non canonico": { bg: "#fbeef6", color: "#b23c8e", dot: "#C64BB4" },
  "Incerto": { bg: "#fff6e6", color: "#b57d12", dot: "#f59e0b" },
};

export const CAT_COLORS = {
  "Paramisha": "#9055E9",
  "Rogia": "#C64BB4",
  "Zoo Zoo": "#16B8D6",
  "Sconosciuta": "#506780",
};
